<template>
  <div>
    <v-alert v-if="dancers.items.length === 0" icon="person" type="info" :value="true">
      {{ $t('alerts.create_dancer_before_starter') }}
    </v-alert>

    <item-list
        v-else
        :items="starterTemplatesCopy"
        :data-table-config="dataTableConfig"
        :actions="tableActions"
        :tooltips="tooltips"
        :lockActions="lockActions"
        :header="$t('starter_template')"
        :show-actions="actions"
        :selectable="selectable"
        :selected.sync="selectedItems"
        :loading="loading"
    >
    </item-list>

    <starter-template-info-dialog :id="starterId" :value.sync="detailsDialog"></starter-template-info-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ItemList from '../common/ItemList';
import StarterTemplateInfoDialog from '../dialogs/StarterTemplateInfoDialog';

export default {
  components: {
    'item-list': ItemList,
    'starter-template-info-dialog': StarterTemplateInfoDialog
  },
  props: {
    selected: {
      type: Array,
      default: null
    },
    selectable: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: null
    },
    rules: {
      type: String,
      default: 'sdf-2021'
    },
    showBroken: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedItems: {
      deep: true,
      handler() {
        this.$emit('update:selected', this.selectedItems);
      }
    },
    starterTemplates: {
      deep: true,
      handler() {
        this.copyStarterTemplates();
      }
    },
    items: {
      deep: true,
      handler() {
        this.copyStarterTemplates();
      }
    },
    selected() {
      this.$set(this, 'selectedItems', this.selected);
    }
  },
  computed: {
    dataTableConfig() {
      let config = {
        loadingDataText: 'Lade Starter',
        noDataText: 'Keine Starter vorhanden',
        rowsPerPageText: 'Zeilen pro Seite',
        headers: [
          {text: this.$t('name'), value: 'name', align: 'left'},
          {text: this.$t('dancer_count'), value: 'dancer_count'}
        ],
        items: {
          large: [
            {value: 'name', class: 'text-xs-left'},
            {value: 'dancer_count'}
          ],
          small: [
            {value: 'name'},
            {value: 'dancer_count'}
          ]
        }
      };

      config.headers.push({text: this.$t('type'), value: `possible_starter_types.${this.rules}`, sortable: false});
      config.headers.push({text: 'Mögliche Alterklassen', value: `age_groups.${this.rules}`, sortable: false});

      config.items.large.push({
        value: `possible_starter_types.${this.rules}`,
        formatFunction: '$t',
        default: 'abhängig von Meldung'
      });
      config.items.large.push({
        value: `age_groups.${this.rules}`,
        formatFunction: '$join',
        default: 'abhängig von Meldung'
      });

      return config;
    },
    ...mapState(['starterTemplates', 'dancers'])
  },
  data() {
    return {
      starterTemplatesCopy: {items: [], loaded: false},
      selectedItems: [],
      starterId: 0,
      detailsDialog: false,
      lockActions: false,
      tableActions: [
        {
          label: this.$t('details'),
          icon: 'info',
          click: starter => {
            this.starterId = starter.id;
            this.detailsDialog = true;
          }
        },
        {
          label: this.$t('edit'),
          icon: 'edit',
          click: starter => {
            this.$router.push(`/user/starter-template/edit/${starter.id}`);
          }
        },
        {
          label: this.$t('delete'),
          icon: 'delete',
          click: starter => {
            this.$store.commit('confirm', {
              headline: 'Starter löschen',
              text: this.$t('questions.remove', [starter.name]),
              callback: () => {
                this.lockActions = true;

                axios.delete(`/api/v1/starter_templates/${starter.id}`).then(response => {

                  if (!response.data.success) {
                    return;
                  }

                  this.$store.commit('removeStarterTemplate', starter.id);

                  this.$store.commit('snackBar', {
                    color: 'success',
                    text: this.$t('was_deleted', [starter.name])
                  });

                  this.lockActions = false;
                }, errorResponse => {
                  console.log(errorResponse);
                  this.lockActions = false;
                });
              }
            });
          }
        }
      ],
      tooltips: [
        {
          visible: starter => {
            return this.showBroken && this.$needDancersBirthday(starter);
          },
          label: this.$t('contains_broken_dancers'),
          color: 'yellow',
          icon: 'warning'
        }
      ]
    }
  },
  mounted() {
    this.copyStarterTemplates();
  },
  methods: {
    copyStarterTemplates() {
      let starterTemplatesCopy = [];
      let starterTemplates;
      if (this.items !== null) {
        starterTemplates = _.cloneDeep(this.items);
      } else {
        starterTemplatesCopy = _.cloneDeep(this.starterTemplates);
        starterTemplates = _.cloneDeep(this.starterTemplates.items);
        starterTemplatesCopy.items = [];
      }

      _.each(starterTemplates, starterTemplate => {
        let needs = this.$needDancersBirthday(starterTemplate);

        if (!needs || (needs && this.showBroken)) {
          if (this.items !== null) {
            starterTemplatesCopy.push(starterTemplate);
          } else {
            starterTemplatesCopy.items.push(starterTemplate);
          }
        }
      });

      this.$set(this, 'starterTemplatesCopy', starterTemplatesCopy);
    }
  }
}
</script>
